import { Injectable } from '@angular/core';
import { AssignedUserCustomerDto, AssignedUserCustomerServiceProxy } from '@shared/service-proxies/service-proxies';
import { AppSessionService } from '@shared/session/app-session.service';
import { map, Observable, of } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class UserInfoStore {
    constructor(private assignedUserCustomerService: AssignedUserCustomerServiceProxy, private appSession: AppSessionService, private activatedRoute: ActivatedRoute) {}

    getUserInfosCall(): Observable<AssignedUserCustomerDto[]> {
        if (this.appSession?.userId) {
            return this.assignedUserCustomerService.getAll(false, undefined, undefined, this.appSession.userId, undefined, undefined, undefined).pipe(map((res) => res.items));
        } else {
            return of([] as AssignedUserCustomerDto[]);
        }
    }
}
